import React from "react";
import { Col, Row } from "reactstrap";

const Landing = () => {
    return (
        <React.Fragment>
            <Col lg={7} xs={12}>
                <div className="p-lg-5 p-4 auth-one-bg">
                    <div className="position-relative h-100 d-flex flex-column">
                        
                        <Row>
                            <Col md={6} xs={12}>
                                <h1 className="title-h1">Business online <span style={{color: '#1bc4c5'}}>Trade</span></h1>
                                <p className="title-desc" style={{marginBottom: '30px'}}>Afin de vous accompagner dans le développement des activités internationales de votre Entreprise, BANK OF AFRICA met à votre disposition le portail Business online TRADE pour vous permettre la réalisation de vos opérations de Trade Finance à distance et assurer le suivi de l’état d’avancement de vos différentes transactions initiées en temps réel.
                                </p>
                                <h1 className="title-h1">Business online <span style={{color: '#1bc4c5'}}>Cash</span></h1>
                                <p className="title-desc">Business online CASH vous fournit une vision globale sur l’ensemble de vos comptes et vous permet d’effectuer vos opérations courantes domestiques en toute sécurité..
                                </p>
                                <p className="title-desc">En un clic, vous accédez en temps réel aux relevés de tous vos comptes ouverts auprès de BANK OF AFRICA quel que soit leur devise.
                                </p>
                                <p className="title-desc">Vous pouvez transmettre vos instructions et charger vos fichiers de règlements à tout moment.
                                </p>
                            </Col>                      
                        </Row>
                    </div>
                </div>
            </Col>
        </React.Fragment >
    );
};

export default Landing;